module.exports = __webpack_public_path__ + "static/img/bg2.318f6e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg2.jpg
// module id = /LkK
// module chunks = 1